import React from "react";
import { Box, Flex, Text, Button, HStack } from "@chakra-ui/react";
import { Badge } from "../../components/common/general";
import { AccountOutline } from "../../assets/icons/components";

interface Props {
  onSkip: () => void;
  onContinue: () => void;
}
const WelcomeModal = ({ onSkip, onContinue }: Props) => {
  return (
    <Box maxW={"365px"}>
      <Flex>
        <Badge leftIcon={<AccountOutline />} variant={"cyan"} label="Profile" size="lg" />
      </Flex>
      <Text mt={"ms-8"} mb={"ms-16"} textStyle="body1-md">
        Welcome! Complete your profile to start applying at Masai School.
      </Text>
      <Flex>
        <HStack ml={"auto"} spacing={2}>
          <Button onClick={onSkip} variant="tertiary" size="md">
            skip
          </Button>
          <Button onClick={onContinue} variant="primary" size="md">
            continue
          </Button>
          {/* </Link> */}
        </HStack>
      </Flex>
    </Box>
  );
};

export default WelcomeModal;
